module.exports = __webpack_public_path__ + "img/youbeizixun@2x.75ff59f0.png";